import type { CustomerDto, User } from "@yalana/contracts";

type AuthState = {
  user: User | null;
  authorizedTenants: CustomerDto[];
  loading: boolean;
};

export type AuthAction =
  | {
      type: "INITIALIZE";
      payload: {
        user: User | null;
        authorizedTenants: CustomerDto[];
      };
    }
  | { type: "SET_USER"; payload: User | null }
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "LOGOUT" };

export function authReducer(state: AuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case "INITIALIZE":
      return {
        ...state,
        user: action.payload.user,
        authorizedTenants: action.payload.authorizedTenants,
        loading: false,
      };
    case "SET_USER":
      return { ...state, user: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "LOGOUT":
      return {
        user: null,
        authorizedTenants: [],
        loading: false,
      };
    default:
      return state;
  }
}
